import React from "react";

export const Like = () => {
  return (
    <svg
      width="9.44"
      height="11.03"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.4397 0.62793C4.12977 0.627935 3.83943 0.779553 3.66232 1.0339L0.798541 5.14635C0.260772 5.9186 0.0210864 6.85957 0.123877 7.79499L0.344094 9.79901C0.4382 10.6554 1.1105 11.3337 1.966 11.4355L3.39864 11.6059C4.49265 11.7361 5.60191 11.6233 6.64733 11.2755C7.37908 11.0322 7.96519 10.4767 8.24757 9.75914L9.40381 6.8208C9.45974 6.67868 9.49839 6.53034 9.51894 6.379C9.6978 5.06132 8.50717 3.96969 7.20993 4.262L4.57216 4.85637L5.35705 1.81174C5.51162 1.21217 5.05888 0.627919 4.4397 0.62793Z"
        fill="#474747"
      />
    </svg>
  );
};
